<template>
  <div class="GoodsList">
    <!-- <div class="sortBox">
      <span class="title">排序：</span>
      <span
        :class="['normal', { selected: sortMode === 0 }]"
        @click="changeSortMode(0)"
        >默认</span
      >
      <span
        :class="['normal', { selected: sortMode !== 0 }]"
        @click="changeSortMode(3)"
      >
        价格
        <i
          :class="['iconfont', 'icon-arrows-4-7', { selected: sortMode === 1 }]"
        /><i
          :class="['iconfont', 'icon-arrows-4-7', { selected: sortMode === 2 }]"
        />
      </span>
    </div> -->
    <div class="screen">
      <div class="cell">
        <div class="label">品牌</div>
        <div class="value" :style="{ height: more ? 'auto' : '50px' }">
          <div
            v-for="(item, index) in brandList"
            :key="index"
            :class="brandId === item.id ? 'active' : ''"
            @click="changeBrand(item.id)"
          >
            {{ item.value }}
          </div>
        </div>
        <div class="more" @click="more = !more">
          {{ !more ? '更多' : '收起' }}
          <img
            src="../../assets/img/down.svg"
            alt=""
            :class="more ? 'rotated' : ''"
          />
        </div>
      </div>
    </div>
    <template v-if="goodsList.length > 0">
      <ul class="goodsList">
        <GoodsItem
          v-for="(item, index) in goodsList"
          :key="index"
          :id="item.id"
          :img="
            item.rguiigpafo0pe0my && item.rguiigpafo0pe0my.length > 0
              ? item.rguiigpafo0pe0my[0].url
              : ''
          "
          :name="item.avdrlfwlhg7kywxn"
          :price="item.f93blbqlvdtdt65v"
          :section="item.dzornqdwofgytboq"
          :sku="item.levmoblohezp7y50"
        />
      </ul>
      <div class="pagination" v-if="goodsList && goodsList.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>
    <p class="noGoods" v-else>
      <img src="../../assets/img/search.svg" alt="" />
    </p>
  </div>
</template>

<script>
import GoodsItem from "../../components/GoodsItem";
import { online, relationOptions } from "@/api/platform";

export default {
  name: "GoodsList",
  components: {
    GoodsItem,
  },
  computed: {
    isSearchPage () {
      return Number(this.typeId) === 0 ? true : false;
    },
    typeId () {
      return this.$route.params.typeId || 0;
    },
    keyword () {
      return this.$route.query.searchText || "";
    },
  },
  data () {
    return {
      goodsList: [],
      brandId: "",
      page: 1, // 页数
      limit: 20,
      total: 0,
      form_head_uuid: "1906dfc5e0ce4e7cb7d6324b06e6d470",
      more: false,
      brandList: [],
      id: ''
    };
  },

  methods: {
    async getListBrands () {
      const { result } = await relationOptions({
        field_uuid: "bf20183860ca4e23ba2e301d49be629d",
        form_head_uuid: "bdc9ab24525d43818588fa136d5cd3da",
        keyword: "",
        type: "quick_screen",
      });
      this.brandList = result;
    },
    async getGoodsList () {
      const { page, form_head_uuid, brandId, limit } = this;
      const { meta, result } = await online({
        page,
        limit,
        keyword:this.keyword,
        select_option: "",
        form_head_uuid,
        lkru2wjadtwwzlh8: brandId ? [brandId] : "",
        '8ufiw69wm435kw5j': this.id || this.$route.query.sort ? [this.id || this.$route.query.sort] : ''
      });
      this.goodsList = result;
      this.total = meta ? meta.total : 0;
    },
    changeBrand (e) {
      this.page = 1;
      this.brandId = this.brandId === e ? "" : e;
      this.getGoodsList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getGoodsList();
    },
    handleCurrentChange (page) {
      this.page = page;
      this.getGoodsList();
    },
    changeSortMode (mode) {
      if (mode === 3) {
        this.sortMode = this.sortMode === 1 ? 2 : 1;
      } else {
        this.sortMode = 0;
      }
    },
  },

  mounted () {
    if (this.$route.query) this.id = this.$route.query.id
    // 品牌列表
    this.getListBrands();
    //类别页
    if (!this.isSearchPage) {
      this.getGoodsList();
    } else {
      //搜索结果页
      this.page = 1;
      this.getGoodsList();
    }
  },

  watch: {
    $route (to, from) {
      console.log(to);
      this.sortMode = 0;
      if (to.query.sort) {
        this.page = 1;
        this.getGoodsList();
      } else if (!this.isSearchPage) {
        this.getGoodsList();
      } else {
        this.page = 1;
        this.getGoodsList(to.query.searchText);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.GoodsList {
  .goodsList {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fill, 232px);
  }
  .screen {
    // border-bottom: 1px dotted @borderColor;
    // margin: 30px auto;
    padding: 30px 0;
    .cell {
      display: flex;
      justify-content: space-between;
      padding: 0 12px 0 24px;
      .value {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        div {
          line-height: 50px;
          margin-right: 40px;
          cursor: pointer;
        }
        .active {
          color: #ff6a6c;
          font-weight: bold;
        }
      }
      .label,
      .more {
        line-height: 50px;
      }
      .label {
        width: 104px;
      }

      .more {
        height: 50px;
        cursor: pointer;
        // display: flex;
        // justify-content: center;
        // align-items: flex-start;
        display: flex;
        align-items: center;
        img {
          width: 15px;
          margin-left: 5px;
          transition: transform 0.5s ease;
          // line-height: 50px;
        }
        .rotated {
          transform: rotate(-180deg);
        }
      }
    }
  }
  // .sortBox {
  //   width: 90%;
  //   border-top: 1px dotted @borderColor;
  //   border-bottom: 1px dotted @borderColor;
  //   margin: 30px auto;
  //   padding-bottom: 30px;
  //   padding-top: 30px;
  //   span {
  //     font-size: 13px;
  //   }
  //   .title {
  //     color: @fontDefaultColor;
  //     display: inline-block;
  //     margin-right: 10px;
  //   }
  //   .normal {
  //     cursor: pointer;
  //     color: @fontDefaultColor;
  //     display: inline-block;
  //     margin-right: 10px;
  //   }
  //   .iconfont {
  //     color: @fontDefaultColor;
  //     display: inline-block;
  //     position: relative;
  //     left: -3px;
  //     &:last-of-type {
  //       transform: rotate(180deg);
  //       left: -6px;
  //     }
  //   }
  //   .selected {
  //     color: @thirdColor;
  //   }
  // }
  .noGoods {
    margin: 200px auto;
    text-align: center;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/client/GoodsList.vue